import React, { useId, useState } from "react";
import "../styles/HelpDisclosure.css";

const HelpDisclosure = ({ title = "Quick help", items = [], compact = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();

  return (
    <div className={`help-disclosure ${compact ? "help-disclosure--compact" : ""}`}>
      <button
        type="button"
        className="help-disclosure__button"
        aria-expanded={isOpen}
        aria-controls={panelId}
        onClick={() => setIsOpen((open) => !open)}
      >
        {compact ? "?" : "Need Help?"}
      </button>

      {isOpen && (
        <div id={panelId} className="help-disclosure__panel">
          <h3>{title}</h3>
          <div className="help-disclosure__items">
            {items.map((item) => (
              <div className="help-disclosure__item" key={item.question}>
                <strong>{item.question}</strong>
                <p>{item.answer}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpDisclosure;
